import axios from "axios";
import Qs from "qs";
import CryptoJS from "crypto-js";
import { REGISTER_DETAILS } from "../redux/action_type";
import { onLogOut } from "../services";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { onJustReducerUpdate } from "../redux/action";
import {googleLogout } from "@react-oauth/google";
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { detectIncognito } from "detectincognitojs";

const pendingRequest = new Map();


var BASE_URL = "";
var setupAPI = function () {
    BASE_URL = `${process.env.REACT_APP_API_URL}`;
};

setupAPI();

function generateReqKey(config) {
    const { method, url, params, data } = config;
    return [method, url, Qs.stringify(params), Qs.stringify(data)].join("&");
}

function addPendingRequest(config) {
    const requestKey = generateReqKey(config);
    config.cancelToken =
        config.cancelToken ||
        new axios.CancelToken((cancel) => {
            if (!pendingRequest.has(requestKey)) {
                pendingRequest.set(requestKey, cancel);
            }
        });
}

function removePendingRequest(config) {
    const requestKey = generateReqKey(config);
    if (pendingRequest.has(requestKey)) {
        const cancelToken = pendingRequest.get(requestKey);
        cancelToken(requestKey);
        pendingRequest.delete(requestKey);
    }
}

const decryptResponse = (res) => {
    const originalResponse = CryptoJS.AES.decrypt(res, process.env.REACT_APP_API_SECRET_KEY).toString(CryptoJS.enc.Utf8);
    return JSON.parse(originalResponse);
}

const encryptResponse = (res) => {
    var encryptResponse = CryptoJS.AES.encrypt(JSON.stringify(res), process.env.REACT_APP_API_SECRET_KEY).toString();
    return encryptResponse
}

const onHandleLogout = (deviceId,incognito) => {
    let authData = localStorage.getItem(REGISTER_DETAILS)
    authData = JSON.parse(authData)
    // if (!authData) {
    //     return
    // }
    let payload={
        device_id:deviceId,
        is_incognito:incognito
    }
    onLogOut(payload).then((res) => {
        if (res.status) {
            window?.google.accounts.id.disableAutoSelect();
            googleLogout();
            window?.FB?.logout()
            localStorage.removeItem(REGISTER_DETAILS)
            window.location.href = '/';
            // dispatch(onJustReducerUpdate({}, PROFILE_DETAILS))
        }
    })
}

const fetchClient = () => {
    
    const defaultOptions = {
        baseURL: BASE_URL,
        // timeout: 20000,
        headers: {
            "Content-Type": "application/json",
        },
    };

    // Create instance
    let instance = axios.create(defaultOptions);
    // instance.defaults.timeout = 30000
    // instance.defaults.timeoutErrorMessage = 'timeout'
    instance.interceptors.response.use(
        function (response) {
            removePendingRequest(response.config); // Remove the request from the pendingRequest object
            return decryptResponse(response.data);
        },
        function (error) {
            removePendingRequest(error?.config || {}); // Remove the request from the pendingRequest object
            //   toast.dismiss();
            //   console.log(error);
            if (error?.code === "ERR_CANCELED") {
                // Timeout error
                // toast.error("Something went wrong...");
            } else if (error?.response?.status === 401) {
                const fpPromise = FingerprintJS.load()
                fpPromise
                    .then(fp => fp.get())
                    .then(result => {
                        const visitorId = result.visitorId
                        // setDeviceId(visitorId)
                        detectIncognito().then((result) => {
                            // setIncognito(result.isPrivate)
                            onHandleLogout(visitorId, result.isPrivate)
                        }).catch((err) => console.log(false));

                    })
                // localStorage.clear();
                // onHandleLogout();
                // toast.error(error?.response?.data.message);
                // window.location.href = '/';
            }
            return Promise.reject(error?.response?.data);
        }
    );

    // Set the AUTH token for any request
    instance.interceptors.request.use(
        function (config) {
            config.headers[`app-Id`] = "JOSH_APP";
            config.headers[`appuser`] = "false";
            if (window?.newsHuntAction) {
                config.headers[`appuser`] = "true";
            }
            // if (process.env.REACT_APP_ENV === "development") {
            //     config.headers[`x-api-key`] = "LocalAuth";
            // }
            let authData = localStorage.getItem(REGISTER_DETAILS)
            authData = JSON.parse(authData)
            if (authData && Object.keys(authData)?.length !== 0) {
                let value = { authToken: authData?.token, "clientID": authData?.josh_client_id, "userUUID": authData?.josh_user_id, id: authData?.id }
                // console.log("123value",value,encryptResponse(value))
                config.headers.Authorization = encryptResponse(value)
            }
            if (["/update-profile", "/update-store"].includes(config.url)) {
                config.headers[`Content-Type`] = "multipart/form-data"
            }

            // Timeout
            config.timeout = 30000; // Milliseconds

            removePendingRequest(config); // Check whether there is a duplicate request, if so, cancel the request
            addPendingRequest(config); // Add the current request information to the pendingRequest object

            return config;
        },
        function (error) {
            // Do something with request error
            return Promise.reject(error);
        }
    );

    return instance;
};

export default fetchClient();
